import { API_AUTH, API_AUTH_FILE } from "../common";

const BanHangApi = {
  getData: ({
    Type,
    SearchText,
    UserName,
    TrangThai,
    DateFrom,
    DateTo,
    pageIndex,
    pageSize
  }) =>
    API_AUTH.get(
      `QuanLyMuaBan/BanHang/DanhSachBanHang?Type=${Type}&SearchText=${SearchText}&UserName=${UserName}&TrangThai=${TrangThai}&DateFrom=${DateFrom}&DateTo=${DateTo}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  getChiTietBanHang: (OrderID) =>
    API_AUTH.get(`QuanLyMuaBan/BanHang/GetChiTietBanHang?orderID=${OrderID}`),

  themSuaBanHang: (data) =>
    API_AUTH.post(`QuanLyMuaBan/BanHang/ThemSuaBanHang`, data),

  getListTaiSanBanHang: ({ loaiTaiSanId, khoId, searchText }) =>
    API_AUTH.get(
      `QuanLyMuaBan/BanHang/GetListTaiSanBanHang?loaiTaiSanId=${loaiTaiSanId}&khoId=${khoId}&searchText=${searchText}`,
      {}
    ),

  xoaBanHang: (OrderID) => 
    API_AUTH.post(`QuanLyMuaBan/BanHang/XoaBanHang?orderID=${OrderID}`),

  getChiTietInDonHang: (orderID) => API_AUTH.get(`QuanLyMuaBan/BanHang/GetChiTietInDonHang?orderID=${orderID}`),

  getInBanHang: (orderID) => API_AUTH.get(`QuanLyMuaBan/BanHang/InPhieuBanHang?orderID=${orderID}`),

  getInChenhLech: (orderID) => API_AUTH.get(`QuanLyMuaBan/BanHang/InPhieuChenhLech?orderID=${orderID}`),
}
export default BanHangApi;